









































































import Vue from 'vue'
interface Item {
    title?: string
    appendSubtitle?: boolean
    subtitle?: string
    subtitleIcon?: string
    link?: string
    append?: boolean
    appendContent?: number
    appendColor?: string
    badge?: boolean
    badgeColor?: string
    badgeContent?: string
    badgeIcon?: string
    disabledPopup?: boolean
    icon?: string
    iconColor?: string
    iconTooltip?: string
    groupItem?: boolean
    id?: string
    idx?: number
    group?: boolean
    hidden?: boolean
    groupItems?: object[]
    method?: boolean
    methodParams?: object[]
    callback?: Function
}
export default Vue.extend({
    props: {
        item: {
            type: Object,
            required: true
        },
        min: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    computed: {
        groupClass(): string {
            //  If we are NOT a group item, return pl-6
            if (!this.item.groupItem) return 'pl-6'
            //  Else, depends on if expanded or not
            return this.min ? 'ml-0 pl-6' : 'ml-4'
        },
        actionStyle(): object {
            //  Grab our margin styling
            const marginStyle = {
                'margin-right': this.item.groupItem ? '0px !important' : '10px !important'
            }

            //  If we are NOT min then just use the margin style
            if (!this.min) return marginStyle

            //  Else, we have these so our icons appear nice n pretty
            return {
                'margin-left': '0px !important',
                'margin-right': '0px !important',
                'padding-left': '0px !important',
                width: '100%',
                display: 'flex',
                'justify-content': 'center',
                'align-items': 'center'
            }
        },
        itemClass(): string {
            //  If this is minified then return 0 margin and 0 padding
            if (this.min) return 'pl-0 ml-0'

            //  Else, it depends on if this is a group item or not
            return this.item.groupItem ? 'ml-4' : 'pl-6'
        },
        subtitleStyle(): object {
            //  Our styling for our font size
            const fontStyle = { 'font-size': '11px' }

            //  If we are on a small or larger screen, then use JUST font style
            if (this.$vuetify.breakpoint.smAndUp) return fontStyle

            //  Else, return a combination of styles
            return {
                ...fontStyle,
                'max-width': '115px',
                'text-overflow': 'ellipsis',
                overflow: 'hidden',
                display: 'block',
                margin: '0 !important'
            }
        },
        titleStyle(): object {
            //  Our styling for our font size
            const fontStyle = { 'font-size': this.item.groupItem ? '14px' : '16px' }

            //  If we are on a small or larger screen, then use JUST font style
            if (this.$vuetify.breakpoint.smAndUp) return fontStyle

            //  Else, return a combination of styles
            return {
                ...fontStyle,
                'max-width': '115px',
                'text-overflow': 'ellipsis',
                overflow: 'hidden',
                display: 'block',
                margin: '0 !important'
            }
        }
    },
    methods: {
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Access Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        async goToLink(item: Item): Promise<void> {
            //  Check if this item is disabled
            const disabled = item.disabledPopup

            //  If it is, then pop our disabled dialog
            if (disabled) return this.disabledPopup()

            //  If this is for the help button, pop the help modal
            if (item.id === 'help-button') {
                // Close the App navigation Drawer if screen is small and smaller
                if (this.$vuetify.breakpoint.smAndDown)
                    this.$store.commit('appDrawerSet', false)

                //  Pop Help Modal
                this.$store.commit('helpModalSet', true)
            }

            // If the item has a callback function, return the item to the callback function
            if (item.callback) return item.callback(item)

            //  Check if we're already on the route
            const isSelf = this.$route.fullPath === item.link

            //  If we're already on the route, do nothing
            if (isSelf) return

            //  Else, navigate to the route
            //  If :to="item.link" then we don't need this
            //  && group.item removed here see comments above and refactoring needed.
            if (item.link) await this.$router.push(item.link)
        }
    }
})
